import { defineMessages } from "react-intl";

export default defineMessages({
  paymentOnWebsite: {
    id: "configurePaymentMethod.paymentOnWebsite",
    defaultMessage:
      "Payment <bold>after the service</bold> on Ring Twice website. Reminder: pay the service provider directly is not allowed.",
  },
});
